<template>
<section class="period-time">
  <el-select
    v-model="query.granularity"
    size="small"
    style="width:75px;"
    @change="onGranularityChanged"
  >
    <el-option
      v-for="dateOption in filterDateOptions"
      :key="dateOption.value"
      :value="dateOption.value"
      :label="dateOption.label"
    />
  </el-select>

  <el-date-picker
    v-model="query.beginTime"
    :picker-options="startDatePickerOptions"
    :clearable="false"
    :editable="false"
    placeholder="开始时间"
    :type="currentDateOption.type"
    :format="currentDateOption.format"
    value-format="yyyy/MM/dd 00:00:00"
    size="small"
    :style="{
      width: `${currentDateOption.width}px`
    }"
    @change="onBeginTimeChanged"
  />
  <el-select
    v-if="currentDateOption.children"
    v-model="tmpQuery[`begin${currentDateOption.value}`]"
    size="small"
    style="width:110px"
    @change="onBeginTimeChanged"
  >
    <el-option
      v-for="child in currentDateOption.children"
      :key="child.value"
      :value="child.value"
      :label="child.label"
    />
  </el-select>
  <span style="font-size:.7em;color:#606266"> ～ </span>
  <el-date-picker
    v-model="query.endTime"
    :picker-options="endDatePickerOptions"
    :clearable="false"
    :editable="false"
    placeholder="结束时间"
    :type="currentDateOption.type"
    :format="currentDateOption.format"
    value-format="yyyy/MM/dd 23:59:59"
    size="small"
    :style="{
      width: `${currentDateOption.width}px`
    }"
    @change="onEndTimeChanged"
  />
  <el-select
    v-if="currentDateOption.children"
    v-model="tmpQuery[`end${currentDateOption.value}`]"
    size="small"
    style="width:110px"
    @change="onEndTimeChanged"
  >
    <el-option
      v-for="child in currentDateOption.children"
      :key="child.value"
      :value="child.value"
      :label="child.label"
    />
  </el-select>

  <slot />
</section>
</template>

<script>
export default {
  name: 'PeriodTime',
  props: {
    query: {
      required: true,
      type: Object
    },
    startDatePickerOptions: {
      required: true,
      type: Object
    },
    endDatePickerOptions: {
      required: true,
      type: Object
    },
    showOptions: Array
  },
  data () {
    return {
      tmpQuery: {
        beginquarter: 0,
        endquarter: 0,
        beginhalf_year: 0,
        endhalf_year: 0
      }
    }
  },
  computed: {
    dateOptions () {
      return [{
        value: 'hour',
        label: '小时',
        width: 169,
        type: 'date',
        format: 'yyyy年MM月dd日 HH:00:00',
        beginTimeFormatter: date => date.format('yyyy/MM/dd 00:00:00'),
        endTimeFormatter: date => date.format('yyyy/MM/dd 23:59:59')
      }, {
        value: 'day_and_night',
        label: '昼夜',
        width: 169,
        type: 'date',
        format: 'yyyy年MM月dd日',
        beginTimeFormatter: date => date.format('yyyy/MM/dd 00:00:00'),
        endTimeFormatter: date => date.format('yyyy/MM/dd 23:59:59')
      }, {
        value: 'day',
        label: '日',
        width: 169,
        type: 'date',
        format: 'yyyy年MM月dd日',
        beginTimeFormatter: date => date.format('yyyy/MM/dd 00:00:00'),
        endTimeFormatter: date => date.format('yyyy/MM/dd 23:59:59')
      }, {
        value: 'month',
        label: '月',
        width: 140,
        type: 'month',
        format: 'yyyy年MM月',
        beginTimeFormatter: date => date.format('yyyy/MM/01 00:00:00'),
        endTimeFormatter: date => {
          date.setDate(1)
          date.setMonth(date.getMonth() + 1)
          date.setDate(0)
          return date.format('yyyy/MM/dd 23:59:59')
        }
      }, {
        value: 'quarter',
        label: '季',
        width: 110,
        type: 'year',
        format: 'yyyy年',
        children: [{
          value: 0,
          label: '第一季度'
        }, {
          value: 1,
          label: '第二季度'
        }, {
          value: 2,
          label: '第三季度'
        }, {
          value: 3,
          label: '第四季度'
        }],
        beginTimeFormatter: (date, startQuarter) => {
          let month = startQuarter * 3
          date.setMonth(month)
          return date.format('yyyy/MM/01 00:00:00')
        },
        endTimeFormatter: (date, endQuarter) => {
          let month = (endQuarter + 1) * 3
          date.setDate(1)
          date.setMonth(month)
          date.setDate(0)
          return date.format('yyyy/MM/dd 23:59:59')
        }
      }, {
        value: 'half_year',
        label: '半年',
        width: 110,
        type: 'year',
        format: 'yyyy年',
        children: [{
          value: 0,
          label: '上半年'
        }, {
          value: 1,
          label: '下半年'
        }],
        beginTimeFormatter: (date, startHalfYear) => {
          let month = startHalfYear * 6
          date.setMonth(month)
          return date.format('yyyy/MM/01 00:00:00')
        },
        endTimeFormatter: (date, endHalfYear) => {
          let month = (endHalfYear + 1) * 6
          date.setDate(1)
          date.setMonth(month)
          date.setDate(0)
          return date.format('yyyy/MM/dd 23:59:59')
        }
      }, {
        value: 'year',
        label: '年',
        width: 110,
        type: 'year',
        format: 'yyyy年',
        beginTimeFormatter: date => date.format('yyyy/01/01 00:00:00'),
        endTimeFormatter: date => date.format('yyyy/12/31 23:59:59')
      }, {
        value: 'arbitrary',
        label: '任意',
        width: 170,
        type: 'date',
        format: 'yyyy年MM月dd日',
        beginTimeFormatter: date => date.format('yyyy/MM/dd 00:00:00'),
        endTimeFormatter: date => date.format('yyyy/MM/dd 23:59:59')
      }]
    },
    filterDateOptions () {
      let {showOptions, dateOptions} = this

      if (Array.isArray(showOptions) && showOptions.length > 0) {
        let showOptionsMap = showOptions.reduce((map, value) => {
          map[value] = true
          return map
        }, {})

        return dateOptions.filter(dateOption => showOptionsMap[dateOption.value])
      }

      return dateOptions
    },
    currentDateOption () {
      let {granularity} = this.query
      return this.dateOptions.find(dateOption => dateOption.value === granularity)
    },
    isSameYear () {
      let {query} = this
      return new Date(query.beginTime).getFullYear() === new Date(query.endTime).getFullYear()
    }
  },
  methods: {
    onGranularityChanged () {
      let {currentDateOption, query} = this
      query.beginTime = currentDateOption.beginTimeFormatter(new Date(query.beginTime), this.tmpQuery[`begin${currentDateOption.value}`])
      query.endTime = currentDateOption.endTimeFormatter(new Date(query.endTime), this.tmpQuery[`end${currentDateOption.value}`])
    },
    onBeginTimeChanged () {
      let {query, currentDateOption} = this
      query.beginTime = currentDateOption.beginTimeFormatter(new Date(query.beginTime), this.tmpQuery[`begin${currentDateOption.value}`])
    },
    onEndTimeChanged () {
      let {query, currentDateOption} = this
      query.endTime = currentDateOption.endTimeFormatter(new Date(query.endTime), this.tmpQuery[`end${currentDateOption.value}`])
    }
  }
}
</script>

<style lang="scss" scoped>
.period-time {
  .data-range {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/PeriodTime.vue